import { RegistrationConfig } from '@us-registration/util-models';
import { AppConfig } from '../../models/config/app-config.type';

export const registrationConfigFactory = ({
  features,
  ...config
}: AppConfig): RegistrationConfig => ({
  adobeCampaignApi: config.adobeCampaignApi,
  adobeCampaignBrand: config.adobeCampaignBrand,
  adobeCampaignEventType: config.adobeCampaignEventType,
  applianceLookupUrlBase: config.applianceLookupUrlBase,
  applianceMaximumAgeInMonths: config.applianceMaximumAgeInMonths,
  applianceRegistrationLimit: config.applianceRegistrationLimit,
  callCentreNumber: config.callCentreNumber,
  clientBrandCode: config.clientBrandCode,
  commonApi: config.usaServiceBaseUrl,
  cpgFinderApi: config.cpgFinderApi,
  defaultWarranty: config.defaultWarranty,
  features: {
    annualPlans: features.annualPlans,
    applianceDetailsSteppedForm: features.applianceDetailsSteppedForm,
    maintenanceEnabled: features.maintenanceEnabled,
    privacyPolicyCheckbox: features.privacyPolicyCheckbox,
    protectionUpsellCheckbox: features.protectionUpsellCheckbox,
    protectionUpsellPage: features.protectionUpsellPage,
    sendRegistriaOrderInfo: features.sendRegistriaOrderInfo,
    wibEnabled: features.wibEnabled,
  },
  checkoutApi: config.checkoutApi,
  modelNumberSearchEnabledBrands: config.modelNumberSearchEnabledBrands,
  partsWarranty: config.partsWarranty,
  possibleNowApi: config.possibleNowApi,
  possibleNowFilterId: config.possibleNowFilterId,
  possibleNowSalt: config.possibleNowSalt,
  registrationApi: config.registrationApi,
  registriaUsersApi: config.registriaUsersApi,
  serializationApi: config.serializationApi,
  retailerFieldEnabledBrands: config.retailerFieldEnabledBrands,
  retailerDomain: config.retailerDomain,
  warrantyLengthInYears: config.warrantyLengthInYears,
  wibApi: config.wibApi,
  preWibApi: config.preWibApi,
});
